module.exports = __webpack_public_path__ + "static/img/2.MRT-SATA-Card-Reverse-Side-1.5eb2018.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/2.MRT-SATA-Card-Reverse-Side-1.jpg
// module id = M8sA
// module chunks = 1